import { hexColorToRGBA } from '@/views/chart/chart/util'
import { componentStyle, seniorCfg } from '../common/common'
import {BASE_ECHARTS_SELECT, DEFAULT_LABEL, DEFAULT_TOOLTIP} from '@/views/chart/chart/chart'
import { getStrByLang } from '@/utils'
import {valueFormatter} from "@/views/chart/chart/formatter";



export function baseMixOption(chart_option, chart) {
  // 处理shape attr
  let customAttr = {}
  const yAxis = JSON.parse(chart.yaxis)
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))


   tooltip.formatter = params => {
        let seriesType=params.seriesType
      if(seriesType=='line'){
         let datavalue=params.value
        return (datavalue *100).toFixed(2)+'%'
      }else{
        return params.value + ''
       }
      }
      chart_option.tooltip = tooltip
      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }
  // 处理data
  const yAxisSeriesMaxList = []; const yAxisExtSeriesMaxList = []
  if (chart.data) {
    chart_option.title.text = chart.title


    let yAxisData=[];
    chart.data.x.forEach(function(value) {
      let lvalue=getStrByLang(value)
      yAxisData.push(lvalue);
    });
    chart_option.xAxis.data =yAxisData
    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]
      y.type = y.type ? y.type : 'bar'
      // color
      y.itemStyle = {
        color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
      }
      // size
      if (customAttr.size) {
        // bar
        if (y.type === 'bar') {
          if (customAttr.size.barDefault) {
            y.barWidth = null
            y.barGap = null
          } else {
            y.barWidth = customAttr.size.barWidth
            y.barGap = customAttr.size.barGap
          }
        }
        // line
        if (y.type === 'line') {
          y.symbol = customAttr.size.lineSymbol
          y.symbolSize = customAttr.size.lineSymbolSize
          y.lineStyle = {
            width: customAttr.size.lineWidth,
            type: customAttr.size.lineType
          }
          y.smooth = customAttr.size.lineSmooth
         /*  let  labelFormatter =  {
              type: 'value', // auto,value,percent
              unit: 1, // 换算单位
              suffix: '', // 单位后缀
              decimalCount: 2, // 小数位数
              thousandSeparator: false// 千分符
          } */
        //  let  line_data=[]

         // if(y.data){
          //  for (let i = 0; i < y.data.length; i++) {
              //  let temp = y.data[i]
                //temp.value=valueFormatter(temp.value, labelFormatter)
              //  line_data.push(temp);
           // }
         // }
        }
        // scatter
        if (y.type === 'scatter') {
          y.symbol = customAttr.size.scatterSymbol ? customAttr.size.scatterSymbol : 'circle'
          y.symbolSize = customAttr.size.scatterSymbolSize ? customAttr.size.scatterSymbolSize : 20
        }
      }
      // label
      if (customAttr.label) {
        y.label = customAttr.label
      }
      y.name=getStrByLang(y.name)
      y.label.formatter=getStrByLang(y.label.formatter)
      chart_option.legend.data.push(y.name)
      i >= yAxis.length ? (y.yAxisIndex = 1) : (y.yAxisIndex = 0)

      // get max
      if (i >= yAxis.length) {
        const valueList = []
        y.data.forEach(ele => {
          valueList.push(ele.value)
        })
        yAxisExtSeriesMaxList.push(Math.max.apply(null, valueList))
      } else {
        const valueList = []
        y.data.forEach(ele => {
          valueList.push(ele.value)
        })
        yAxisSeriesMaxList.push(Math.max.apply(null, valueList))
      }

      y.selectedMode = true
      y.select = BASE_ECHARTS_SELECT
      chart_option.series.push(y)
    }
  }

  componentStyle(chart_option, chart)

  // 若轴值中最大值小于data的最大值，则轴值最大值设置失效
  if (yAxisSeriesMaxList.length > 0 && !isNaN(chart_option.yAxis[0].max)) {
    const max = Math.max.apply(null, yAxisSeriesMaxList)
    if (max > chart_option.yAxis[0].max) {
      delete chart_option.yAxis[0].max
    }
  }
  if (yAxisExtSeriesMaxList.length > 0 && !isNaN(chart_option.yAxis[1].max)) {
    const max = Math.max.apply(null, yAxisExtSeriesMaxList)
    if (max > chart_option.yAxis[1].max) {
      delete chart_option.yAxis[1].max
    }
  }


  seniorCfg(chart_option, chart)
  return chart_option
}
